import { FC, useState } from 'react'
import styles from './EditCompanyShortInformation.module.css'
import { Formik, FormikValues } from 'formik'

import CustomInput from '../UI/CustomInput/CustomInput'
import InputMask from 'react-input-mask'
import s from '../../styles/common/Form.module.css'
import p from '../UI/CustomInput/CustomInput.module.css'
import iconEdit from '../../assets/icons/iconEdit.svg'

import * as yup from 'yup'

import { useAppDispatch, useAppSelector } from '../../redux/types/types'

import {
  changeCompanyShortInformation,
  getCurrentCompany,
} from '../../redux/actions/companiesAction'

import CompanyPageDescription from '../CompanyPageDescription/CompanyPageDescription'
import { ItemInfo } from '../ItemInfo/ItemInfo'
import CustomButton from '../UI/CustomButton/CustomButton'
import TitleBlockForEditPages from '../TitleBlockForEditPages/TitleBlockForEditPages'
import { useToast } from '../../context/ToastContext'

export type EditCompanyShortInformationPropsType = {
  companyId: number
  city: string
  address: string
  phone: string
  email: string
  description?: string
}

const EditCompanyShortInformation: FC<EditCompanyShortInformationPropsType> = ({
  companyId,
  phone,
  email,
  city,
  address,
  description,
}) => {
  const [editMode, setEditMode] = useState(false)

  const { userRole, token } = useAppSelector((state) => state.auth)

  const { showSuccess, showError } = useToast()

  const dispatch = useAppDispatch()

  const handleSubmitHandler = async (values: FormikValues) => {
    const mobileWithoutSymbols = `+${values.phone.replace(/[\D]+/g, '')}`

    const resultAction = await dispatch(
      changeCompanyShortInformation({
        token,
        companyId: String(companyId),
        email: values.email,
        contactPhone: mobileWithoutSymbols,
        city: values.city,
        address: values.address,
        description: values.description,
      }),
    )

    if (changeCompanyShortInformation.rejected.match(resultAction)) {
      showError('Произошла ошибка при изменении данных')
    } else {
      showSuccess('Данные успешно изменены')
      setEditMode(false)
      await dispatch(getCurrentCompany({ companyId: String(companyId), token }))
    }
  }

  const validationSchema = yup.object().shape({
    city: yup.string().required('Поле является обязательным'),
    address: yup.string().required('Поле является обязательным'),
    phone: yup.string().required('Поле является обязательным'),
    email: yup.string().required('Поле является обязательным'),
  })

  const handleEditMode = () => {
    setEditMode(true)
  }

  return (
    <div className={styles.editCompanyShortInformation}>
      {editMode ? (
        <div className={styles.editMode}>
          <Formik
            initialValues={{
              city: city ? city : '',
              address: address ? address : '',
              email: email ? email : '',
              phone: phone ? phone : '',
              description: description ? description : '',
            }}
            validateOnBlur
            onSubmit={(values) => handleSubmitHandler(values)}
            validationSchema={validationSchema}
          >
            {(props) => {
              const { values, touched, errors, isValid, handleChange, handleBlur, handleSubmit } =
                props

              return (
                <>
                  <TitleBlockForEditPages
                    setEdit={setEditMode}
                    title={'Основная информация'}
                    disabled={false}
                    handleSubmit={handleSubmit}
                  />
                  <div className={styles.container}>
                    <div className={styles.fullNameBlock}>
                      <div className={styles.leftBlock}>Город</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='city'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.city}
                          className={
                            errors.city && touched.city
                              ? `${styles.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                      </div>
                    </div>
                    <div className={styles.fullNameBlock}>
                      <div className={styles.leftBlock}>Адрес</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='address'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address}
                          className={
                            errors.address && touched.address
                              ? `${styles.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                      </div>
                    </div>
                    <div className={styles.phoneBlock}>
                      <div className={styles.leftBlock}>Номер телефона</div>
                      <div className={styles.rightBlock}>
                        <InputMask
                          mask='+7 (999) 999 9999'
                          type='phone'
                          placeholder='Введите'
                          name='phone'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phone}
                          className={
                            errors.phone && touched.phone
                              ? `${s.inputError} ${p.input} ${styles.input}`
                              : `${p.input} ${styles.input}`
                          }
                        ></InputMask>
                      </div>
                    </div>
                    <div className={styles.fullNameBlock}>
                      <div className={styles.leftBlock}>E-mail</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='email'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          className={
                            errors.email && touched.email
                              ? `${styles.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              )
            }}
          </Formik>
        </div>
      ) : (
        <div className={styles.shortInformationBlock}>
          <div className={styles.header}>
            <h2 className={styles.title}>Основная информация</h2>
            {(userRole === 'superAdmin' ||
              userRole === 'admin' ||
              userRole === 'employeePlace' ||
              userRole === 'directorPlace' ||
              userRole === 'directorAgent') && (
              <CustomButton
                iconSrc={iconEdit}
                className={styles.btn}
                title={''}
                onClick={handleEditMode}
              />
            )}
          </div>
          <div className={styles.container}>
            <div className={styles.leftBlock}>
              <div className={styles.cityBlock}>
                <ItemInfo title='Город' value={city} />
              </div>
              <div className={styles.cityBlock}>
                <ItemInfo title='Адрес' value={address} />
              </div>
              <div className={styles.companyNameBlock}>
                <ItemInfo title='Телефон' value={phone} />
              </div>
              <div className={styles.capacityBlock}>
                <ItemInfo title='Электронная почта' value={email} />
              </div>

              {description && <CompanyPageDescription text={description} />}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EditCompanyShortInformation
